import axios from 'axios'
import store from '@/store'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 15000 // 请求超时时间
  // 设置请求次数，请求的间隙
  // headers: {
  //     retry: 4,
  //     retryDelay: 1000
  // }
})
// // 跨域请求，允许保存cookie
// service.defaults.withCredentials = true
// request拦截器
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['content-type'] = 'application/json'
    config.headers['Authorization'] = 'Bearer ' + store.getters.token // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config
}, error => {
  // Do something with request error
  console.error(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    return res
  },
  error => {
    console.info(error)
    /*
    var msg = ''
    switch (error.response.status) {
      case 400: msg = error.response.data || '当前网络不佳，请稍后重试. [404]'; break
      default: msg = '音视频服务异常'; break
    }

    if (msg) {
      Message({
        message: msg,
        type: 'error',
        duration: 3 * 1000
      })
    }
    */
    return Promise.reject(error)
  }
)

export default service




// WEBPACK FOOTER //
// ./src/utils/request3.js